<template>
  <div>
    <!-- <Advisor :messages="messages"></Advisor> -->
    <!-- && isNotWhitelabel -->
    <accordion-steps 
     v-if="isLocalhost || isNotWhitelabel"
    :steps="steps"></accordion-steps>
    <!-- Alerts -->
    <div class="fixed-top">
      <!-- No Traffic Alert Bar -->
      <div
        v-if="(notraffic && alertPlan.includes($session.get('paid_plan')) && !isFirstLogin && !showPaymentUnsuccessful)"
        :key="key"
        class="alert alert-danger full-alert py-1"
        style="z-index: 1"
      >
        <div class="row">
          <div class="col-md-9 my-auto">
            <font-awesome-icon
              icon="info-circle"
              class="fa fa-md text-danger mr-2"
            />
            <!-- You're almost there! 👉&nbsp; -->
            <!-- <u
              class="cursor-pointer"
              @click="$router.push({ path: '/dashboard' })"
              >Install</u
            > -->
            <!-- analytics tracking code to start collecting data. -->

             <b class="mr-2">No data</b> Install tracking code to start capturing
            data, analyzing user behavior and getting insights.
          </div>
          <div class="col-md-3 text-right">
            <button class="btn btn-sharp-red" @click="openTracking()" v-bind:class="{ disabled: isChecking }">
              <span v-if="!isChecking">Install tracking code</span>
              <span v-else>Processing...</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Upgrade Plan Alert Bar -->
      <!-- <div
        v-if="showUpgradeAlert"
        class="alert alert-primary full-alert py-1"
        role="alert"
        style="z-index: 1"
      >
        <div class="row">
          <div class="col-md-9 my-auto">
            <font-awesome-icon
              icon="info-circle"
              class="fa fa-md text-primary mr-2"
            />
            <b class="mr-2"
              >Based on our estimation, your website will exceed the current
              plan limit by the end of the month. Upgrade your plan to avoid
              missing out on visitors' data.</b
            >
          </div>
          <div class="col-md-3 text-sm-right text-decoration-underline">
            <button
              type="button"
              class="hide-upgrade-btn"
              @click="hideUpgradeAlert()"
            >
              Do not show this again
            </button>
          </div>
        </div>
      </div> -->
      <!-- If the session is full -->
      <div class="alert alert-danger  full-alert py-1"   style="z-index: 1" v-if="showFullAlert" role="alert">
        <div class="row">
          <div class="col-md-9 my-auto">
            <font-awesome-icon
              icon="info-circle"
              class="fa fa-md text-danger mr-2"/>
            Your account has used up all monthly sessions on <b>{{dateWarning}}</b>. Upgrade your plan to view more sessions
          </div>
          <div class="col-md-3 text-right">
            <button v-if="$session.get('whitelabel_ref_id') === 0" class="btn btn-sharp-red" @click="$router.push({ path: '/checkout' })">
              <span>Upgrade Plan</span>
            </button>
            <button v-else class="btn btn-sharp-red" @click="$router.push({ path: '/newcheckout' })">
              <span>Upgrade Plan</span>
            </button>
          </div>
        </div>
      </div>
      <!-- if there's Unsuccessful charge -->
      <div class="alert alert-danger  full-alert py-1"   style="z-index: 1" v-if="showPaymentUnsuccessful" role="alert">
        <div class="row">
          <div class="col-md-9 my-auto">
            <font-awesome-icon
              icon="info-circle"
              class="fa fa-md text-danger mr-2"/>
              Failed to process your payment. Keep your visitor data from being permanently deleted by updating your payment details.
          </div>
          <div class="col-md-3 text-right">
            <button class="btn btn-sharp-red" @click="$router.push({ path: '/subscription' })">
              <span>Update Payment</span>
            </button>
          </div>
        </div>
      </div>
      
      <div v-if="showInstallationBanner()" :key="key" class="alert alert-orange full-alert py-1" style="z-index: 1">
        <div class="row">
          <div class="col-md-9 my-auto font-weight-bold">
            <font-awesome-icon icon="info-circle" class="fa fa-md mr-2" /> Action required: Please install the Mida pixel on your site to start A/B testing!
          </div>
          <div class="col-md-3 text-right">
            <button class="btn btn-outline-muted py-1 my-1" @click="openTracking()" v-bind:class="{ disabled: isChecking }">
              <span v-if="!isChecking">🛠️ Installation Guide</span>
              <span v-else>Processing...</span>
            </button>
          </div>
        </div>
      </div>

    </div>

    <announcement :message="message"></announcement>

    <div 
    :style="((notraffic && alertPlan.includes($session.get('paid_plan'))) || showInstallationBanner() || showFullAlert || showPaymentUnsuccessful) && ($isHowuku || alertPlan.includes($session.get('paid_plan'))) && !isFirstLogin? 'margin-top: 49px;' : ''">
      <Header v-if="!$isOptimize && !$isMida"></Header>
      <!-- Do not change menu for whitelabel specifically for 6ix -->
      <!-- Because we don't want to break their site with custom CSS -->
      <SideMenuLite
        :style="
          notraffic || showUpgradeAlert || showFullAlert ||showPaymentUnsuccessful && !isFirstLogin? 'max-height: calc(100% - 49px);' : ''
        "
        v-if="$isOptimize || $isMida"
      ></SideMenuLite>      
      <SideMenu
        :style="
          notraffic || showUpgradeAlert || showFullAlert ||showPaymentUnsuccessful && !isFirstLogin? 'max-height: calc(100% - 49px);' : ''
        "
        v-else-if="$isHowuku || $session.get('paid_plan') === 104 || isWhitelabelClient"
      ></SideMenu>
      <SideMenuOld v-else></SideMenuOld>

      <!-- <button title="Show navigation" class="aside__toggle-button">
        <svg
          width="14"
          height="7"
          viewBox="0 0 14 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L7 6L13 1"
            stroke="var(--accent-theme-color)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button> -->

      <div class="page-wrapper">
        <div class="container-fluid" :style="$isOptimize ? 'margin-top:0px !important' : ''">
          <slot />
        </div>
      </div>
      <Footer></Footer>
    </div>
    <modal name="show-code" :adaptive="true" width="100%" height="100%" style="z-index: 999999;" @before-close="cleanChecking">
      <GetCode :secretCode="secretKey" :selectedWidgetId="widgetId"></GetCode>
    </modal>
    <modal
      name="show-install"
      :adaptive="true"
      width="850px"
      height="90%"
      class="dark-modal-overlay"
      style="z-index: 999999;"
    >
      <InstallRecommendation :recommendPlugin="recommendPlugin" :selectedWidgetId="widgetId" :isNotAddWebsite="true"/>
    </modal>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import SideMenu from '@/layouts/menus/SideMenu.vue'
import SideMenuLite from '@/layouts/menus/SideMenuLite.vue'
import SideMenuOld from '@/layouts/menus/SideMenuOld.vue'
import Footer from '@/components/Footer.vue'
const GetCode = () => import('@/components/GetCode.vue')
const InstallRecommendation = () => import('@/components/InstallRecommendation.vue')
// import Advisor from '@/components/AdvisorWidget.vue'
import AccordionSteps from '@/components/AccordionSteps.vue'
import { store } from '@/store'

var axios = require('axios')

export default {
  components: {
    Header,
    SideMenu,
    SideMenuLite,
    Footer,
    SideMenuOld,
    GetCode,
    AccordionSteps,
    InstallRecommendation
    // Advisor,
  },
  store,
  data: function () {
    return {
      isIdle: false,
      showingBanner: false,
      marginSize: 0,
      usageEstimation: 0,
      planSize: 0,
      planSessionSize: 0,
      pageview: 0,
      created_at:0,
      dateWarning:0,
      showUpgradeAlert: false,
      showFullAlert:false,
      showPaymentUnsuccessful:false,
      isLocalhost: false,
      steps: [
        {
          status: 0,
          title: 'Setup tracking code',
          body: 'Please get the <a onclick="openTracking();">tracking code</a> and make the necessary changes, and try the button below.'
        },
        {
          status: 0,
          title: 'Watch recording',
          body: `Watch your visitor use your website like watching a CCTV playback. You will know how visitor browse your website, where they click and stop.`,
          image: 'https://thumbs2.imgbox.com/54/46/fBTKdvqm_t.png',
          link: '/recordings',
          link2: 'https://howuku.freshdesk.com/support/solutions/articles/150000072492-what-is-session-recordings-',
          label: 'Watch Recoding',
          label2: 'Learn More'
        },
        {
          status: 0,
          title: 'View heatmap',
          body: 'Understand your website hot spot and cold spot. Heatmaps provide a comprehensive view of your website page where the spot that your visitors click the most and click the least, how much of your page is visible to visitors and which element catch the visitor attention.',
          image: 'https://images2.imgbox.com/34/d4/y9AFqtW0_o.png',
          link: '/heatmap',
          link2: 'https://howuku.freshdesk.com/support/solutions/articles/150000072491-what-is-heatmaps-',
          label: 'View Heatmap',
          label2: 'Learn More'
        },
        {
          status: 0,
          title: 'View website event',
          body: 'The event performed by visitors on the website will be automatically captured. With the event tracking analysis, you will know who is the visitor, where the source of the visitor and etc.',
          image: 'https://thumbs2.imgbox.com/67/3e/y1uXydNa_t.png',
          link: '/events',
          link2: 'https://howuku.freshdesk.com/support/solutions/articles/150000072493-what-is-event-tracking-',
          label: 'View Event',
          label2: 'Learn More'
        },
        // {
        //   status: 0,
        //   title: 'Setup A/B test',
        //   body: 'Performing a marketing experiment by setting up two versions of a web page to determine which makes the higher conversion.',
        //   image: 'https://thumbs2.imgbox.com/3d/3d/VH46sbmc_t.png',
        //   link: '/ab-test',
        //   link2: 'https://howuku.freshdesk.com/support/solutions/articles/150000072497-what-is-ab-testing-',
        //   label: 'Create A/B Test',
        //   label2: 'Learn More'
        // },
        {
          status: 0,
          title: 'Create Funnel',
          body: `Funnel show you exactly where and when visitors are dropping out of your website. Setup your own funnel such as purchase funnel, webinar sign up funnel.  `,
          image: 'https://thumbs2.imgbox.com/55/c4/PyKGyRgm_t.png',
          link: '/funnel',
          link2: 'https://howuku.freshdesk.com/support/solutions/articles/150000072494-what-is-conversion-funnel-',
          label: 'Create Funnel',
          label2: 'Learn More'
        },
        // {
        //   status: 0,
        //   title: 'More features',
        //   body: `Find out more on other features such as Feedback, Survey, Analytics, Form abandonment and etc.`,
        //   image: 'https://thumbs2.imgbox.com/f1/9f/XhMqp4iL_t.png',
        //   link: 'https://howuku.freshdesk.com/support/solutions/150000151178',
        //   label: 'Learn More',
        // }
      ],
      isVisitor: false,
      interval: null,
      key: 0,
      notraffic: false,
      secretKey: '',
      widgetId: '',
      messages: [
        // {
        //   subject: 'User NPS to get feedback from your website',
        //   tag: ['optimization idea'],
        //   body: 'This is just a testing message to see how it would work in action',
        //   image: 'https://i.stack.imgur.com/uZqgF.jpg',
        //   link: 'https://howuku.com',
        //   label: 'Continue',
        // },
      ],
      isFirstLogin: false,
      recommendPlugin: '',
      websiteURL: '',
      isChecking: false,
      isNotWhitelabel:false,
      isWhitelabelClient: false,
      alertPlan: [801, 802, 803],
      deadSessionCount: 0
    }
  },
  beforeMount() {
    this.widgetId = this.$session.get('widget_id')
    this.isLocalhost = window.location.href.startsWith('http://localhost:')
    this.isVisitor = window.location.href.includes('/visitor/')
    this.isNotWhitelabel = window.location.href.includes('.howuku.com')

    this.$http.get(process.env.API_ENDPOINT + '/plan').then((response) => {
      let data = response.data
      let plan_id = this.$session.get('paid_plan')

      for (let i = 0; i < data.length; i++) {
        if (data[i].plan_id === plan_id) {
          this.planSize = data[i].pageview
          this.planSessionSize = data[i].sessions + data[i].rewarded_session
        }
      }
    })
    this.checkForUnsucessfullCharge()


    setInterval(() => {
      this.$http.get(process.env.API_ENDPOINT + '/app/version')
      .then((result) => {
        if (result && result.data && result.data.version !== localStorage.getItem('_app_version')) {
          localStorage.setItem('_app_version', result.data.version)
          window.location.reload()
        }
      })      
    }, 120 * 1000)

    setInterval(() => {
      if (this.isIdle) this.checkSession()
      this.isIdle = true
    }, 180 * 1000)

    document.addEventListener("mousemove", (event) => {
      this.isIdle = false
    });

    document.addEventListener("keyup", (event) => {
      this.isIdle = false
    });
  },
  async mounted() {    
    setTimeout(async () => {
      await new Promise((resolve) => {
        try {
          mida.onFeatureFlags(() => {
            console.log('Feature flag loaded')
            resolve()
          })
        } catch(e){
          resolve()
        }
      })
    }, 1000);

    setTimeout(() => {
      this.showingBanner = this.showInstallationBanner()
      let intervalBanner = null

      if (this.showingBanner) {
        this.$auditlog({
          module: 'installation',
          action: 'Show banner',
        })
      }

      if (this.showingBanner) {
        intervalBanner = setInterval(() => {
          if (!this.showInstallationBanner()) {
            clearInterval(intervalBanner);
          }

          this.$checkInstallationStatus()

        }, 10000)
      }      
    }, 2000);

    // check whitelabl_ref_id
    if (!this.$isMida) {
      this.$http
        .get(process.env.API_ENDPOINT + '/getCompany')
        .then((response) => {
          let info = response.data[0]
          if (info.whitelabel_ref_id) {
            this.isWhitelabelClient = true
          }
        })
    }
    // user's preference on alert
    let key = 'hide_upgrade_alert'
    let alertPreference = await this.$findAuditlog({
      module: 'notifications',
      action: key
    })
    //this.$session.get('role') === 0 && // is owner
    if (
      alertPreference && // Check if alertPreference is not null
      alertPreference.length === 0 && // was not previously shown in audit log
      window.location.href.includes('.howuku.com') // not whitelabel
    ) {
      setTimeout(() => this.checkUsageEstimation(), 1500)
    }

    if (!this.$isMida)this.checkFor30DayExpire()

    if (this.$session.get('language')) {
      this.$initTranslation().then(() => {
        this.$translate.setLang(this.$session.get('language'))
      })
    }

    // setTimeout(() => {
    //   let firstLogin = this.$session.get('first_login')

    //   this.isFirstLogin = false
    //   if (firstLogin && firstLogin === 'yes') this.isFirstLogin = true
    // }, 200);

    // Instead of get 'first_login' in beforeMount, use async mounted to wait to date to be fetched then only render the component to screen
    // this one should keep as axios otherwise $http.post will kick user logout when route changes
    setInterval(() => {
      axios.post(process.env.API_ENDPOINT + '/ping').then(() => {
        this.deadSessionCount = 0
      })
      .catch((err) => {
        if (this.deadSessionCount > 3) {
          this.$swal.fire('Oppss..', 'Your session has expired.', 'warning')
          this.$router.push({ path: '/logout' })
        }
        this.deadSessionCount++
      })
    }, 12000)


    // identify current user
    setTimeout(() => {
      let notTestEnvironment =
        !window.location.href.includes('localhost') &&
        !window.location.href.includes('demo.howuku.com') &&
        !window.location.pathname === '/hwlogin'
      if (notTestEnvironment && window.howuku) {
        window.howuku
          .identify({
            id: this.$session.get('user_id'),
            name: this.$session.get('name'),
            email: this.$session.get('email'),
            company_id: this.$session.get('company_id'),
            odd_number: Number(this.$session.get('company_id')) % 2,
            plan: this.$session.get('paid_plan'),
            lifetime: this.$session.get('lifetimedeal') ? 'Y' : 'N'
          })
          .then(() => {})
      }
    }, 2000)

    // this.$initTranslation().then(() => {
    //   this.$translate.setLang('zh')

    //   setInterval(() => {
    //     if (window.untranslated) {
    //       console.log('post translation', window.untranslated)

    //       let list = window.untranslated
    //       let tlist = list.filter(function (item, pos, self) {
    //         return self.indexOf(item) == pos
    //       })

    //       this.$http
    //         .post(process.env.API_ENDPOINT + '/translation', {
    //           translation: JSON.stringify(tlist),
    //         })
    //         .then((response) => {
    //           window.untranslated = null
    //         })
    //         .catch((err) => {
    //           console.error(err)
    //         })
    //     }
    //   }, 5000)
    // })

    this.interval = null
    let traffic = 0
    this.secretKey = this.$session.get('secretkey')
    if (!this.$isMida && !traffic) { this.checkCurrentTraffic().then((traffic) => {}) }
  },
  methods: {
    showInstallationBanner() {
      return this.$store.getters.showInstallationBanner || localStorage.getItem('banner:installation') === 'true'
    },    
    hideUpgradeAlert() {
      let key = 'hide_upgrade_alert'
      this.$auditlog({
        module: 'notifications',
        action: key
      })
      this.showUpgradeAlert = false
    },
    checkUsageEstimation() {
      this.$http.get(process.env.API_ENDPOINT + '/usage').then((response) => {
        if (!response.data || response.data.length === 0) {
          console.error('No usage data received');
          return;
        }

        let data = response.data[0];
        
        if (data && (data.pageview !== 0 || data.session)) {
          let usage = this.planSessionSize ? data.session : data.pageview;
          let pastDays = new Date().getDate() - 1;
          if (pastDays === 0) pastDays = 1;
          this.usageEstimation = Math.round((usage / pastDays) * 30);
          
          var checkForShowUpgradeAlert = ((this.planSessionSize && this.usageEstimation > this.planSessionSize) || 
          (!this.planSessionSize && this.usageEstimation > this.planSize));

          if (this.planSessionSize && usage < this.planSessionSize && checkForShowUpgradeAlert && this.showPaymentUnsuccessful !== true) {
            this.showUpgradeAlert = true;
          }

          if (this.planSessionSize && usage > this.planSessionSize && this.showPaymentUnsuccessful !== true) {
            this.getLastUsageDate();
            this.showFullAlert = true;
          }
        }
      }).catch(error => {
        console.error('Error fetching usage data:', error);
      });
    },
    checkForUnsucessfullCharge() {
      this.$http.get(process.env.API_ENDPOINT + '/getPaidExpiryRetry').then((response) => {
        if (!response.data) {
          console.error('No data received for unsuccessful charge check');
          return;
        }
        console.log(response.data.prohibit);
        if (response.data.prohibit === 1) {
          this.showPaymentUnsuccessful = true;
        }
      }).catch(error => {
        console.error('Error checking for unsuccessful charge:', error);
      });
    },
    checkFor30DayExpire() {
      this.$http.get(process.env.API_ENDPOINT + '/checkFor30DayExpire').then((response) => {
        if (!response.data) {
          console.error('No data received for 30-day expiry check');
          return;
        }
        if (response.data.prohibit === 1) {
          this.$swal.fire({
            html: '<h5 class="font-weight-bold">There is a problem with payment for this account</h4><p>Your account has been <span style="text-decoration: underline">suspended</span>.</p> <div><p>Please update your credit card details or contact us at<br><span style="text-decoration: underline">customer.support@howuku.com</span> to discuss.</p></div>',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'rgba(var(--main-color),1)',
            cancelButtonColor: '#ebedf2',//#dcdcdc
            confirmButtonText: 'Update Credit Card',
            cancelButtonText:'Contact the billing team',
            allowOutsideClick: false,
            customClass: 'swal-wide',
            reverseButtons : true
          }).then((result) => {
            if (result.dismiss == "cancel") {
              window.location.href = "mailto:customer.support@howuku.com"
              window.location.reload()
            }else{
              this.$router.push({ path: '/card/add' })
            }
          });
        }
      }).catch(error => {
        console.error('Error checking for 30-day expiry:', error);
      });
    },
    getLastUsageDate() {
      this.$http.get(process.env.API_ENDPOINT + '/lastUsageDate').then((response) => {
        if (!response.data || response.data.length === 0) {
          console.error('No last usage date data received');
          return;
        }
        this.dateWarning = moment(response.data[0].created_at).format('DD MMM YYYY');
      }).catch(error => {
        console.error('Error fetching last usage date:', error);
      });
    },
    openTracking() {

      try {
        this.$auditlog({ module: 'installation', action: 'click_installation_banner' })  
        this.$track('click_installation_banner')
      } catch(e) {}      

      this.isChecking = true
      if (this.$isHowuku || this.$isMida || this.$isOptimize || window.location.host.includes('localhost')) {
        let data = {
          websiteURL: this.websiteURL
        }
        // website CMS check
        this.$http.post(process.env.API_ENDPOINT + '/checkWebsite', data)
          .then((response) => {
            this.recommendPlugin = response.data
            this.$modal.show('show-install')
            this.isChecking = false
          })
          .catch((err) => {
            this.isChecking = false
            this.errorMsg = 'Error checking website CMS'
            console.log(err)
          })
      } else this.$modal.show('show-code')
    },
    checkSession() {
      // console.log('check session')
      if (this.$session.exists()) {
        this.$http.get(process.env.API_ENDPOINT + '/user').then((result) => {
          if (result && result.data && result.data.length) {
            let hasChanges = false
            // if value changes, force reload
            // console.log(result)
            
            if (this.$session.get('role') !== result.data[0].role && !this.$session.get('bypass')) {
              this.$session.set('role', result.data[0].role)
              hasChanges = true
            }

            if (this.$session.get('paid_plan') !== result.data[0].paid_plan && result.data[0].paid_plan) {
              this.$session.set('paid_plan', result.data[0].paid_plan)
              hasChanges = true
            }

            if (hasChanges) window.location.reload()

            // if account is not active force logout
            if (result.data[0].status !== 1) {
              this.$router.push({ path: '/logout' })
            }
          }
        })

        if (
          this.$session.get('isAuth0') &&
          (!this.$auth.isAuthenticated ||
            this.$auth.user.email !== this.$session.get('email'))
        ) {
          // check if auth0 session still available
          this.$router.push({ path: '/logout' })
        }
      }
    },
    check30dayTraffic() {
      this.$http
        .get(process.env.API_ENDPOINT + '/check/traffic')
        .then((response) => {
          return response.data.length
        })
        .catch((err) => {
          console.error(err)
          return 0
        })
    },
    checkCurrentTraffic() {
      return new Promise((resolve, reject) => {
        if (this.$session.get('widget_id')){
          this.$http
            .post(process.env.API_ENDPOINT + '/getWidgets', {
              widget_id: this.$session.get('widget_id')
            })
            .then(async (response) => {
              if (response.data && response.data.length > 0) {
                this.websiteURL = response.data[0].widget_allowed_website
                let traffic = response.data[0].pageview_total || 0
                if (traffic === 0) this.notraffic = true
                else if (response.data[0].pageview_monthly !== 0) {
                  this.notraffic = false
                } else if (
                  response.data[0].pageview_monthly === 0 &&
                  (await this.check30dayTraffic()) === 0
                ) {
                  this.notraffic = true
                } else {
                  this.notraffic = true
                }
                console.log('NO TRAFFIC', this.notraffic)

                this.key++
                resolve(traffic)
              } else {
                console.error('No widget data received');
                resolve(null)
              }
            })
            .catch(error => {
              console.error('Error fetching widget data:', error);
              resolve(null)
            })
        } else {
          resolve(null)
        }
      })
    },
    cleanChecking() {
      this.isChecking = false
    }
  }
}
</script>
<style>
.page-wrapper {
  margin-left: var(--sidebar-width); /* menubar-width */
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;  
  /* padding-left: calc(calc(100% - 1280px - var(--sidebar-width)) / 2);
  padding-right: calc(calc(100% - 1280px - var(--sidebar-width)) / 2);   */
}

.container-fluid {
  margin-top: 70px;
  /* max-width: 1260px;
  margin-left: auto;
  margin-right: auto; */
}

.full-alert {
  margin: 0px !important;
  border-radius: 0px;
}

.hide-upgrade-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  text-decoration: underline;
  padding: 8px 16px;
}

.btn-sharp-red {
  background-color: #eb3345 !important;
  color: white !important;
}
.swal-wide{
    padding-bottom: 40px ;
    width:750px  !important;
    height: 450px !important;
}
.swal-wide .swal2-cancel{
  color: #2a2a2a !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Auth.vue